var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLungs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26.043,
    viewBox: "0 0 26 26.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(-1.992 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M16.315,15.71a1,1,0,0,1-.55-.166A10.6,10.6,0,0,1,11,6.72V3a1,1,0,0,1,2,0V6.717a8.6,8.6,0,0,0,3.868,7.159,1,1,0,0,1-.552,1.834Z",
    transform: "translate(2.993)",
    fill: "#16c6d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-2",
    "data-name": "secondary",
    d: "M8.761,15.71a1,1,0,0,1-.552-1.834,8.6,8.6,0,0,0,3.868-7.162V3a1,1,0,0,1,2,0V6.717a10.6,10.6,0,0,1-4.765,8.828A1,1,0,0,1,8.761,15.71Z",
    transform: "translate(1.916)",
    fill: "#16c6d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M5.181,26.628a2.332,2.332,0,0,1-2.17-1.478,1,1,0,0,1-.1-.252A31.474,31.474,0,0,1,2,16.672,17.881,17.881,0,0,1,3.74,8.347l.02-.04A3.871,3.871,0,0,1,7.178,6.26h.033a3.876,3.876,0,0,1,3.84,3.263l1.091,6.547A9.313,9.313,0,0,1,5.9,26.513l-.01,0A2.329,2.329,0,0,1,5.181,26.628ZM4.8,24.188a1,1,0,0,1,.06.182.332.332,0,0,0,.422.244,7.313,7.313,0,0,0,4.892-8.2V16.4L9.077,9.849A1.885,1.885,0,0,0,7.211,8.26H7.178a1.875,1.875,0,0,0-1.645.973A15.873,15.873,0,0,0,4,16.628q0,.03,0,.06A29.475,29.475,0,0,0,4.8,24.188Zm20,2.439a2.329,2.329,0,0,1-.706-.11l-.012,0A9.313,9.313,0,0,1,17.844,16.07l1.092-6.55a3.875,3.875,0,0,1,3.839-3.26h.033a3.871,3.871,0,0,1,3.418,2.047l.021.04a17.886,17.886,0,0,1,1.737,8.243,31.474,31.474,0,0,1-.906,8.216,2.332,2.332,0,0,1-2.275,1.82Zm-.1-2.014a.332.332,0,0,0,.421-.247l.006-.027a29.475,29.475,0,0,0,.85-7.731q0-.028,0-.055a15.879,15.879,0,0,0-1.53-7.32,1.874,1.874,0,0,0-1.645-.973h-.033a1.884,1.884,0,0,0-1.866,1.586L19.816,16.4v.008a7.313,7.313,0,0,0,4.891,8.2Z",
    transform: "translate(0 1.415)",
    fill: "#102f74"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungs);
export default __webpack_public_path__ + "static/media/lungs.561d15931ca5e8c99c562bc5569c82b7.svg";
export { ForwardRef as ReactComponent };